/**
 * FormField Component
 * Adapted from web team's "next" project for Vortex
 *
 * Provides a form field wrapper with label, hints, error messages, and character counter.
 */
import React from "react";
import { joinClasses } from "../../../utils/joinClasses";
import { Typography } from "../../typography/Typography";
export const FormField = ({ children, className, disabled, errorMessage, hideLabel, hideErrors, hints = [], hintsTypographyType = "body-md", id, inputLength = 0, label = "", maxLength, ref, showRequiredLabel, }) => {
    // Make sure hints is always an array
    hints = !Array.isArray(hints) ? [hints] : hints;
    return (React.createElement("div", { className: joinClasses(["min-w-0", className], {
            "pointer-events-none opacity-40": disabled,
        }), ref: ref },
        React.createElement("label", { className: joinClasses(["mb-2 flex gap-x-1 text-sm"], {
                "sr-only": hideLabel,
            }), htmlFor: id },
            React.createElement(Typography, { as: "span", typographyType: "body-md" },
                label,
                showRequiredLabel && (React.createElement(Typography, { appearance: "subdued", as: "span", typographyType: "body-md" }, ` (Required)`)))),
        children,
        ((!!errorMessage && !hideErrors) || !!hints.length || !!maxLength) && (React.createElement("div", { className: "flex justify-between pt-1" },
            React.createElement("div", null,
                !!errorMessage && (React.createElement(Typography, { appearance: "none", className: "text-danger-strong", id: `${id}_error` }, errorMessage)),
                !!hints.length && (React.createElement("ul", { className: "flex flex-col gap-y-1", id: `${id}_hints` }, hints.map((hint) => (React.createElement("li", { key: `${id}_${hint}` },
                    React.createElement(Typography, { appearance: "subdued", as: "span", typographyType: hintsTypographyType }, hint))))))),
            !!maxLength && (React.createElement(Typography, { appearance: "none", "aria-label": "remaining character count", className: joinClasses([
                    "font-semibold",
                    maxLength - inputLength <= maxLength * 0.1
                        ? "text-danger-strong"
                        : maxLength - inputLength <= maxLength * 0.25
                            ? "text-warning-strong"
                            : "text-neutral-moderate",
                ]) }, `${maxLength - inputLength} / ${maxLength}`))))));
};
export const FormFieldWrap = ({ children }) => (React.createElement("div", { className: "flex flex-col gap-y-4" }, children));
